import React from 'react';
import PropTypes from 'prop-types';

import { AccountDetails } from 'modules/user/components';
import { OrganizationLogo } from 'modules/common/components';

import HeaderStatus from '../HeaderStatus';

import theme from './Header.scss';

const propTypes = {
  selectedOrganizationToken: PropTypes.number,
  selectedOrganizationLogo: PropTypes.string,
  userExist: PropTypes.bool.isRequired,
  isSessionInitialized: PropTypes.bool.isRequired,
  isClalit: PropTypes.bool.isRequired,
  isMoh: PropTypes.bool.isRequired,
  hideAccountDetails: PropTypes.bool,
};

const defaultProps = {
  selectedOrganizationToken: null,
  selectedOrganizationLogo: null,
  hideAccountDetails: false,
};

const Header = ({
  isMoh,
  isClalit,
  isSessionInitialized,
  selectedOrganizationToken,
  selectedOrganizationLogo,
  userExist,
  hideAccountDetails,
}) => (
  <header className={ theme.header }>
    <div className={ theme.logoWrap }>
      <If condition={ selectedOrganizationToken && selectedOrganizationLogo }>
        <OrganizationLogo />
      </If>
    </div>
    <If condition={ !(isMoh || isClalit) }>
      <HeaderStatus />
    </If>
    <div className={ theme.userIcon }>
      <If condition={ isSessionInitialized && userExist && !hideAccountDetails }>
        <AccountDetails />
      </If>
    </div>
  </header>
);

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;
